import AbstractField from "./AbstractField";

export default class LabelField extends AbstractField {
    isInputField = true;

    populate(element) {
        this.reset();
        element.label.labels.map((value, index) => this.inputs[index].value(value));
    }

    make() {
        this.field = this.p.createDiv()
            .class('input-group');
        this.labelDiv = this.p.createDiv('Labels')
            .parent(this.field)
            .class('input-label');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.applyClasses();
        this.applyStyles();

        this.inputs = [0, 1, 2].map(i => this.createInput(i));
        this.initialized = true;
        return this;
    }

    createInput(index) {
        let inputField = this.p.createInput('')
            .parent(this.field)
            .id('label-' + index)
            .class('input-text')
            .attribute('autocomplete', 'off')
            .style('margin-bottom', '5px')
            .input(() => this.setValue(index));
        this.setFocusAndBlurActions(inputField);
        return inputField;
    }

    value(value) {
        if (value === undefined) {
            return this.getValue();
        }
        this.inputElement.value(value);
        return this;
    }

    setValue(index) {
        let value = this.getValue(index);
        let currentElement = this.getTab('info').currentElement;
        currentElement.label.setValue(index, value);
        this.changesMade();
        currentElement.row.updateLabel();
        if (index == 0 && !currentElement._name) {
            this.getTab('info').input.title.value(value);
        }
    }

    focus() {
        this.inputs[0].elt.focus();
    }

    getValue(index = null) {
        return index !== null
            ? this.inputs[index].value()
            : this.inputs.map(input => input.value());
    }

    setFocusAndBlurActions(inputField) {
        inputField.elt.onfocus = () => {
            this.enableHotKeys = false
            this.getTab('info').activeInput = inputField;
        };
        inputField.elt.onblur = () => {
            this.enableHotKeys = true
            let activeInput = this.getTab('info').activeInput;
            this.getTab('info').activeInput = activeInput == inputField
                ? null
                : activeInput;
        };
    }

    reset() {
        this.inputs.map(input => input.value(''));
    }
}
